const getNextStep = (activeIndex, steps) => {
  const allStepsCount = steps.length;

  const isNextStep = activeIndex + 1 < allStepsCount;
  const nextStep = isNextStep ? activeIndex + 1 : allStepsCount - 1;

  return [isNextStep, nextStep];
};

export default getNextStep;
